module.exports = __webpack_public_path__ + "img/dzbl.b5b81b75.svg";